export default __webpack_public_path__ + "static/img2-4700d98fab97ef9aa46a39b1ca3a49db.png";